<template>
    <v-dialog v-model="dialog" :value="dialog" width="500">
        <v-card>
            <v-toolbar dense flat>
                <v-toolbar-title class="font-weight-bold" :class="($vuetify.theme.dark) ? 'white--text' : 'black--text'">
                    {{ title }}
                </v-toolbar-title>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text v-show="!!message" class="pa-4" :class="($vuetify.theme.dark) ? 'white--text' : 'black--text'" v-html="message"></v-card-text>
            <v-card-actions>
                <v-btn v-on:click="dismiss" :color="($vuetify.theme.dark) ? 'var(--errorDark)' : 'var(--errorLight)'" style="color: black;" class="float-left" :class="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'">Dismiss</v-btn>
                <v-spacer></v-spacer>
                <v-btn v-on:click="confirm" class="float-right" :class="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'">Confirm</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    name: 'ConfirmAlert',
    props:
    {
        // title: String,
        // message: String,
        // dialogValue: Boolean
    },
    data() {
        return {
            resolve: null,
            reject: null,
            dialog: false,
            title: "",
            message: "",
        }
    },
    mounted() {

    },
    methods: {
        open(title, message) {
            this.dialog = true;
            this.title = title;
            this.message = message;
            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });

        },
        dismiss() {
            this.resolve(false);
            this.dialog = false;
        },
        confirm() {
            this.resolve(true);
            this.dialog = false
        }
    }
}
</script>
